<template>
  <v-dialog persistent v-model="show">
    <v-snackbar top v-model="snackbar" :color="snackbarColor" multi-line>
      {{ snackbarText }}
      <v-btn dark icon text @click="snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-card class="pa-4">
      <span class="title">Termos de Uso:</span>
      <v-card text style="height: 300px" class="mt-3 outline">
        <PDF v-bind:url_pdf="url_pdf"></PDF>
      </v-card>
      <v-layout column align-right mb-2>
        <v-btn text @click="downloadPdf" class="ma-0 pb-1">
          <v-icon small class="blue--text text-darken-1">get_app</v-icon>
          <span
            class="font-weight-regular blue--text text--darken-1 pl-1"
            style="text-transform: none"
            >Fazer download do Termo de Uso</span
          >
        </v-btn>
        <v-checkbox
          v-if="showButtons"
          v-model="acceptUserTerms"
          color="success"
          label="Eu li e concordo com os termos de uso."
          class="ma-0 mb-0"
          hide-details
        ></v-checkbox>
      </v-layout>
      <v-layout>
        <v-btn text class="btn-error ma-0" @click="$emit('closeTermsDialog')"
          >SAIR</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          v-if="showButtons"
          class="btn-sucess ma-0 white--text"
          @click="validate()"
          >FAZER RESERVA</v-btn
        >
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
const Constants = require('../../models/constants/Constants.js');
import ClientController from '../../controllers/ClientController';
import PDF from './PDF';
const axios = require('axios');

export default {
  props: {
    configs: { type: Object, default: () => {} },
    show: Boolean,
    showButtons: Boolean,
  },

  components: {
    PDF,
  },

  data() {
    return {
      snackbar: false,
      snackbarColor: '',
      snackbarText: '',
      url_pdf: '',
      acceptUserTerms: false,
      sendEmail: false,
      clientController: new ClientController(this.$resource),
    };
  },

  watch: {
    show(val) {
      if (val) {
        this.setUrlPdf();
      }
    },
  },

  methods: {
    downloadPdf() {
      axios({
        url: this.url_pdf,
        method: 'GET',
        responseType: 'blob', // important
      }).then(response => {
        if (response.data.type == 'application/pdf') {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'termos_UseCar.pdf');
          document.body.appendChild(link);
          link.click();
        }
      });
    },
    setUrlPdf() {
      this.url_pdf = this.configs.term_of_use.value;
    },

    alert(text, color) {
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbar = true;
    },

    validate() {
      if (this.acceptUserTerms) {
        this.$emit('requestCreate');
        this.$emit('closeTermsDialog');
        if (this.sendEmail) {
          this.$emit('sendTermsByEmail');
        }
      } else
        this.alert(
          'É necessário aceitar os termos de uso para a utilização do veículo.',
          'error'
        );
    },
  },
};
</script>

<style scoped>
.outline {
  border: 1px solid rgb(230, 230, 230);
}
</style>
